export function DeleteConfirmModal({ isOpen, itemName, onConfirm, onCancel }) {
  if (!isOpen) return null;

  return (
    <>
      {/* Backdrop */}
      <div 
        className="fixed inset-0 bg-black/30 z-40 transition-opacity"
        onClick={onCancel}
      />
      
      {/* Drawer */}
      <div className="fixed bottom-0 left-0 right-0 bg-white rounded-t-3xl z-50 animate-slide-up max-w-[600px] mx-auto">
        <div className="p-6">
          {/* Title */}
          <h2 className="text-center mb-2">Delete Item?</h2>
          
          {/* Message */}
          <p className="text-center text-gray-600 mb-2">
            Are you sure you want to permanently delete <span className="font-medium">"{itemName}"</span> from your shopping list?
          </p>
            <p className="text-center text-sm text-muted-foreground mb-6">
            This is different from checking it off. The item will be removed completely.
          </p>
          
          {/* Buttons */}
          <div className="flex gap-3">
            <button
              onClick={onCancel}
                className="flex-1 py-3 rounded-full border border-accent text-accent hover:bg-muted transition-colors"
            >
              Cancel
            </button>
            <button
              onClick={() => {
                onConfirm();
              }}
                className="flex-1 py-3 rounded-full bg-destructive text-destructive-foreground hover:bg-destructive/90 transition-colors"
            >
              Delete
            </button>
          </div>
        </div>
        
        {/* Safe area spacing for mobile */}
        <div className="h-[env(safe-area-inset-bottom)]" />
      </div>
    </>
  );
}
